// DS: i8.18
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const HelpCenter: React.FC<Props> = props => (
  <IconWrap {...props}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0ZM8.97266 15.5996H10.9727V13.5996H8.97266V15.5996ZM9.97266 4.40039C8.27469 4.40042 6.85909 5.60962 6.54004 7.21387L8.50195 7.60547C8.63889 6.91814 9.24512 6.40042 9.97266 6.40039C10.8011 6.40039 11.4727 7.07196 11.4727 7.90039C11.4724 8.72861 10.8009 9.40039 9.97266 9.40039C9.42039 9.40043 8.97266 9.84811 8.97266 10.4004V12.2002H10.9727V11.2549C12.4182 10.8246 13.4725 9.48572 13.4727 7.90039C13.4727 5.96739 11.9057 4.40039 9.97266 4.40039Z"
        fill="currentColor"
      />
    </svg>
  </IconWrap>
);
HelpCenter.displayName = 'HelpCenter';

export default HelpCenter;
